import { Component } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import '@wdpr/button';

@Component({
  standalone: false,
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {

  constructor(private authService: AuthService) { }

  public redirectToLogin() {
    this.authService.login();
  }
}
